export default "__VITE_ASSET__DqyVAQH3__"